import { Button } from "react-bootstrap";

export default function KebabButton({ onClick, title = "More options", vertical = true, variant = "outline-primary" }) {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      aria-label={title}
      className="d-inline-flex align-items-center justify-content-center p-2 shadow-none"
      style={{ width: 30, height: 30 }}
    >
      {/* Accessible label for screen readers */}
      <span className="visually-hidden">{title}</span>
      {/* Three vertical dots (no external icon deps) */}
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        role="img"
        aria-hidden="true"
        fill="currentColor"
      >
        {vertical ? (
          <>
            <circle cx="8" cy="3" r="1.5" />
            <circle cx="8" cy="8" r="1.5" />
            <circle cx="8" cy="13" r="1.5" />
          </>
        ) : (
          <>
            <circle cx="3" cy="8" r="1.5" />
            <circle cx="8" cy="8" r="1.5" />
            <circle cx="13" cy="8" r="1.5" />
          </>
        )}
      </svg>
    </Button>
  );
}